export default __webpack_public_path__ + "static/media/pfp.be6d9aec.png";